<template>
  <div>
    <div :class="{'opened': opened, 'container-sacola bg-white': !isComponent}">
      <div class="fixed-top py-4 py-md-3 bg-white shadow-sm mb-3 d-md-none" v-if="!isComponent">
        <div class="container text-center position-relative">
          <a href="javascript:" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar" @click="$emit('close')">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <div class="font-weight-bold m-auto">SACOLA</div>
        </div>
      </div>
      <div>
        <loading v-show="load" fullscrean="true"/>
        <div v-if="!load">
          <div v-if="dados.produtos && dados.produtos.length">
            <div class="container" :class="{'container-produtos-sacola': !isComponent}">
              <div class="card mb-2 px-3 py-2" :class="{'bg-light': !isComponent}" v-for="p in dados.produtos">
                <div>
                  <div class="font-weight-bold float-right text-nowrap">
                    <span class="badge badge-success" v-if="p.id_beneficio">Grátis</span>
                    <span class="font-weight-bold tamanho-1" v-else>{{(p.valor * p.quantidade) | valor}}</span>
                  </div>
                  <p class="mb-0 tamanho-1">{{p.quantidade}}x - {{p.produto.nome_produto}}</p>
                  <p v-for="d in p.divisoes" class="m-0 pl-1 tamanho-2"> # {{d.nome_produto}}</p>
                  <p v-for="d in p.adicionais" class="m-0 pl-1 tamanho-2">
                    + <span v-show="d.qtd > 1">{{d.qtd}}x</span>
                    {{d.nome_produto}} <span v-show="d.valor > 0"> <b>{{((d.valor * d.qtd) * p.quantidade) | valor}}</b></span>
                  </p>
                  <router-link :to="url + '/promocoes'" class="badge badge-warning text-white mr-2" v-if="p.id_beneficio">
                    <icon name="pontos" size="12" class="mr-1"/> Benefício
                  </router-link>
                  <p class="mb-0 tamanho-2" v-show="p.observacao"><b>Obs:</b> {{p.observacao}}</p>
                  <produto-consumo :consumo="p.produto.tipo_consumo" :tipo_pedido="dados.tipo_pedido"/>
                </div>
                <div class="mt-2 mb-1 border-top pt-2">
                  <button class="btn btn-outline-primary btn-sm mr-2" @click="openModalProduto(p)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M127.5 45c-41.7 8.8-74 41.4-82.5 83.2-2 9.6-2 13-1.8 131.1l.3 121.2 2.2 7.7c4.9 17.1 11.2 29.6 21.3 42.1 13.9 17.2 32.8 29.2 56.8 36l7.7 2.2 120.9.3c105.1.2 122.1 0 129.1-1.3 44.2-8.2 77.6-41.6 86-85.8 2.3-12 2.2-150 0-155.5-6.7-16-29.9-17-38.3-1.7-1.5 2.7-1.8 10.6-2.3 76-.6 81-.2 76.7-7.6 91.5-5.4 11-17 22.4-28.4 27.8-14.9 7.1-7.1 6.7-134.9 6.7-93.7 0-116.5-.3-121-1.4-18.1-4.4-35.2-18-42.8-34.1-7.1-15-6.7-7.2-6.7-135s-.4-120 6.7-135c5.4-11.4 16.8-22.9 27.8-28.4 14.9-7.3 10.5-6.9 91.7-7.5l73.1-.6 4.4-3c13.8-9.7 11.8-30.6-3.4-37-3.3-1.3-13-1.5-76.5-1.4-67.4 0-73.5.2-81.8 1.9"/><path d="M395.2 44.4c-11.6 2.9-19.7 8-33.5 21.5-7.1 6.9-13.9 14.4-15 16.6-2.8 5.4-2.8 13.6 0 19 2.7 5 59.5 61.6 64.3 64.1 4.9 2.5 13.4 2.4 18.5-.3 2.2-1.1 9.7-7.9 16.7-15.1 10.9-11.2 13.2-14.1 16.6-21.3 4.7-9.8 6.2-16.2 6.2-26.4s-1.5-16.6-6.2-26.3c-7.3-15.4-22.6-27.8-38.9-31.7-7.7-1.8-21.4-1.8-28.7-.1M298 132.2c-2.7.7-14.7 12.1-53.8 51.1-27.7 27.6-51.2 51.6-52.2 53.2-1 1.7-6.2 20.3-11.5 41.5-8 31.7-9.6 39.5-9.3 44.2.5 6.6 3.3 11.5 9.1 15.5 7.2 5 10.5 4.6 53.7-6.2 21.2-5.3 39.8-10.5 41.5-11.5 1.6-1 25.6-24.5 53.2-52.2 53.4-53.6 52.3-52.3 52.3-61.8-.1-7.7-3-11.4-32.8-41.3-30.5-30.6-34.6-33.8-42.6-33.6-2.3 0-5.7.5-7.6 1.1"/></svg>
                    Editar
                  </button>
                  <button class="btn btn-dark btn-sm" @click="removeItem(p)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M205.5 44.6c-9.7 3.4-15.9 11.8-18.1 24.4-1.5 8.8-2.8 11.3-7.1 14.1-2.6 1.7-5.5 1.9-38.6 1.9-23 0-37.4.4-40.2 1.1-2.7.7-6.3 2.8-9 5.1-11.2 9.8-8.8 27.5 4.6 34.2l5.3 2.6h307.2l5.3-2.6c12.7-6.4 15.5-21.9 5.9-32.8-6.4-7.3-8.1-7.6-50.2-7.6-33.4 0-36.3-.1-38.9-1.9-4.3-2.8-5.6-5.3-7.1-14.1-2.3-12.9-8.4-21.1-18.5-24.5-6.4-2.2-94.5-2.1-100.6.1m-86 127.8c-4 1.7-9.5 7.2-11.1 11.3-.8 1.8-1.4 5.6-1.4 8.5 0 11.1 17 206.6 18.5 212.8 2.2 9.2 10.4 25.4 16.7 33 12.5 15 29.9 25.5 48.8 29.5 10.5 2.2 119.5 2.2 130 0 19.9-4.2 38.6-16 50.6-31.8 5.7-7.4 12.6-21.8 14.8-30.7 2-7.9 18.8-204.3 18.4-214.2-.3-5.6-.9-7.4-3.5-11-1.7-2.4-5-5.3-7.4-6.5l-4.2-2.3H256.1c-108.5.1-134.2.3-136.6 1.4"/></svg>
                    Remover
                  </button>
                </div>
              </div>
              <div class="mt-3" :class="{'d-md-none': !isComponent}">
                <button class="btn btn-primary btn-block" @click="goCategorias()">
                  <i class="fa fa-plus mr-1"></i> <b>Adicionar mais itens</b>
                </button>
              </div>
              <div class="my-4" v-if="recomendados.length">
                <h6 class="font-weight-bold mb-2">Peça também</h6>
                <carrosell :slides="recomendados" :small="true" @selProduto="selProduto"/>
              </div>
            </div>
            <div class="container">
              <hr v-if="isComponent">
              <h6 class="font-weight-bold mb-0">Totais</h6>
              <p class="mb-0">
                <span class="float-right font-weight-bold">{{dados.total | valor}}</span>
                Subtotal
              </p>
            </div>
            <div class="btn-enviar add-sacola mt-3" v-if="dados.produtos && dados.produtos.length && !isComponent">
              <a href="javascript:" class="btn btn-primary btn-block btn-bottom" @click="finalizarPedido()">
                <b>Finalizar Pedido</b>
              </a>
            </div>
          </div>
          <div class="text-center" style="margin: 32px 0" v-else>
            <div class="py-4 text-primary">
              <icon name="sacola" size="100"/>
            </div>
            <div class="small mb-3">Sua sacola está vazia.</div>
            <div>
              <button type="button" @click="goCategorias()" class="btn btn-outline-primary mb-4">Ver Produtos</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <produto ref="sProduto" :empresa-aberta="true" :is-componente="true"/>

    <modal-bottom :opened="modalProduto" v-if="modalProduto && itemEditar.produto">
      <div class="container">
        <div>
          <h6 class="text-center mt-2 mb-3 font-weight-bold">Editar Produto</h6>
          <div class="mb-3">
            <p class="mb-0 mt-1"><b>{{itemEditar.quantidade}}x</b> - {{itemEditar.produto.nome_produto}}</p>
            <div class="small" v-if="itemEditar.produto.qtd_estoque < 20">
              <b>{{itemEditar.produto.qtd_estoque - itemEditar.quantidade | percent}}</b> unidades disponíveis
            </div>
          </div>
          <div class="card p-2 mb-3" v-if="!itemEditar.id_beneficio">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="m-0 font-weight-bold">Quantidade</h6>
              </div>
              <div style="width: 125px;">
                <quantidade :qtd-inicial="itemEditar.quantidade" @change="(qtd) => { this.itemEditar.quantidade = qtd }" :max="itemEditar.produto.qtd_estoque"/>
              </div>
            </div>
          </div>
          <div v-if="empresa.json_config.obs_produto === '1'">
            <div class="h6 mb-0">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" class="fi" viewBox="0 0 512 512"><path d="M233 27.7C139 37.8 61.5 102.6 35.5 193 26 226 24.3 266.9 31 300.1c8.2 40.6 28.3 80.6 54.7 109l4.3 4.6-17.1 12.8c-9.4 7.1-18.2 14.3-19.6 16.1-2.9 3.9-5.3 11.2-5.3 16.4 0 9.3 6.7 19.5 15.4 23.6l5.1 2.4h100.7c109.1 0 110.9-.1 135.6-5.6 43.1-9.6 85-33.4 115.9-65.7 68.2-71.5 83.7-175.3 39.3-262.3-31.1-60.7-87.8-104.5-154.6-119.3-16.3-3.6-31.5-5.1-50.7-4.9-10 0-19.8.3-21.7.5m55 33.4c86 14.6 151.4 81.7 163.4 167.8 2 14 2 38.4.1 52-6.6 46.3-30.5 90.9-65.3 121.6-30.8 27.3-70.7 45.1-110.7 49.5-6.7.7-38.6 1-96.9.8l-86.9-.3 17.2-12.8c17.5-13.1 19.5-15 21.1-20.8 1.9-6.5-.1-10.2-13.3-23.8-13.9-14.3-22.3-25.1-30.3-38.7-14.2-24.1-23-50.3-26.5-78.7-1.5-12.7-.7-43 1.6-55.7 15.9-88.4 87.6-154.3 177.3-163 12.3-1.2 35.7-.2 49.2 2.1"/><path d="M152.5 224.9c-9.2 2.4-17.3 9-21.5 17.6-3.4 6.9-3.5 19.8-.2 26.5 3.4 7.1 7.5 11.4 14.4 15.1 5.8 3.1 7 3.4 14.8 3.3 7.2 0 9.3-.4 13.6-2.6 7.5-4 10.7-7 14.5-14 3.1-5.8 3.4-7 3.4-14.8s-.3-9-3.4-14.8c-5.7-10.4-14.4-16-26-16.7-3.6-.2-7.9-.1-9.6.4m96 0c-9.2 2.4-17.3 9-21.5 17.6-3.4 6.9-3.5 19.8-.2 26.5 3.4 7.1 7.5 11.4 14.4 15.1 5.8 3.1 7 3.4 14.8 3.3 7.2 0 9.3-.4 13.6-2.6 7.5-4 10.7-7 14.5-14 3.1-5.8 3.4-7 3.4-14.8s-.3-9-3.4-14.8c-5.7-10.4-14.4-16-26-16.7-3.6-.2-7.9-.1-9.6.4m96 0c-9.2 2.4-17.3 9-21.5 17.6-3.4 6.9-3.5 19.8-.2 26.5 3.4 7.1 7.5 11.4 14.4 15.1 5.8 3.1 7 3.4 14.8 3.3 7.2 0 9.3-.4 13.6-2.6 7.5-4 10.7-7 14.5-14 3.1-5.8 3.4-7 3.4-14.8s-.3-9-3.4-14.8c-5.7-10.4-14.4-16-26-16.7-3.6-.2-7.9-.1-9.6.4"/></svg>
              Observações ?
            </div>
            <div class="small mb-2">Adicionais pagos não serão inclusos.</div>
            <textarea class="form-control" id="observacoes" rows="3" maxlength="100" placeholder="Descreva aqui as observações deste produto. Ex: Retirar um ingrediente."
                      style="resize: none" v-model="itemEditar.observacao"></textarea>
          </div>
          <div class="font-weight-bold mt-4">
            <button class="btn btn-primary btn-block p-2 mb-3" @click="editarItem">
              <b>Editar - {{(itemEditar.valor * itemEditar.quantidade) | valor}}</b>
            </button>
            <button type="button" class="btn btn-block text-primary" @click="openModalProduto(false)">Cancelar</button>
          </div>
        </div>
      </div>
    </modal-bottom>
  </div>
</template>

<script>
  import Loading from './Loading'
  import ModalBottom from './ModalBottom'
  import Quantidade from "./Quantidade";
  import Icon from "./Icon";
  import ProdutoConsumo from "./ProdutoConsumo";
  import Carrosell from "./Carrosell";
  import Produto from "./Produto";

  export default {
    name: 'CSacola',
    props: ['opened', 'isComponent'],
    components: {Produto, Carrosell, ProdutoConsumo, Icon, Quantidade, Loading, ModalBottom },
    data() {
      return {
        token: localStorage.getItem('token'),
        modalProduto: false,
        item: {},
        itemEditar: { quantidade: 0, observacao: '' },
        load: false,
        url: '',
        recomendados: []
      }
    },

    methods: {
      openModalProduto(p) {
        this.modalProduto = false;
        this.item = {};

        if (p) {
          this.item = p;
          this.itemEditar = {
            produto: p.produto,
            observacao: p.observacao,
            valor: p.valor,
            quantidade: p.quantidade,
            id_beneficio: p.id_beneficio
          };

          setTimeout(() => {
            this.modalProduto = true;
          }, 100);
        }
      },

      editarItem() {
        this.item.observacao = this.itemEditar.observacao;
        this.item.quantidade = this.itemEditar.quantidade;
        this.salvarSacola();
        this.openModalProduto(false);
      },

      removeItem(p) {
        this.$swal({
          text: 'Deseja realmente remover este produto ?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.dados.produtos = this.dados.produtos.filter(obj => obj !== p);
            this.salvarSacola();
          }
        });
      },

      salvarSacola() {
        this.$store.commit('setProdutosSacola', this.dados);
      },

      finalizarPedido() {
        this.$helpers.trackPixel(this, 'InitiateCheckout', this.empresa);
        this.$helpers.trackAnalytics("begin_checkout", {
          currency: "BRL",
          value: this.dados.total,
          items: this.dados.produtos.map(dados => {
            return {
              item_id: dados.produto.id_tabela_preco,
              item_name: dados.produto.nome_produto,
              quantity: dados.quantidade
            }
          })
        });

        if (this.zap) {
          this.$router.push(this.url + '/perfil/login');

        } else {
          this.$router.push(this.url + (this.token ? '/finalizar' : '/perfil/cadastro'));
        }
      },

      goCategorias() {
        if (this.$route.name === 'Categorias') {
          this.$emit('close');
          this.$helpers.focusrElement('search');

        } else {
          this.$router.push(this.url + '/categorias');
        }
      },

      getRecomendados() {
        let recomendados = this.$store.state.recomendados;

        if (recomendados.length) {
          this.fillRecomendadaos(recomendados);
          return;
        }

        const stRecomendados = sessionStorage.getItem('recomendados');

        if (stRecomendados) {
          recomendados = this.$helpers.parseJSONObject(stRecomendados);

          if (recomendados) {
            this.fillRecomendadaos(recomendados);
            return;
          }
        }

        this.$http.get(this.$store.state.base_url + 'recomendados', { params: { tipo_pedido: this.dados.tipo_pedido } })
          .then(response => {
            this.load = false;
            recomendados = response.data || [];
            this.$store.state.recomendados = recomendados;
            sessionStorage.setItem('recomendados', JSON.stringify(recomendados));
            this.fillRecomendadaos(recomendados);

          }, res => {
            this.load = false;
          });
      },

      fillRecomendadaos(recomendados) {
        const ids_sacola = this.dados.produtos.map(s => s.id_produto);
        this.recomendados = recomendados.filter(r => !ids_sacola.includes(r.id_produto));
      },

      selProduto(p) {
        this.$refs.sProduto.openProduto({ id: p.id_produto });
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.empresa.dominio_delivery : '';
      this.getRecomendados();
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa
      },

      dados() {
        return this.$store.state.sacola
      },

      zap() {
        return this.$store.state.zap
      }
    },

    watch: {
      opened(val) {
        if (val && !this.dados.produtos || !this.dados.produtos.length) {
          this.$router.push(this.url + '/categorias');
        }
      }
    },

    created() {
      window.scrollTo(0,0);
      document.body.classList.remove("modal-open");
    },

    filters: {
      phone(phone) {
        if (phone) {
          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone
      }
    }
  }

</script>
<style scoped>
  .btn-enviar {
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e9e9e9;
    padding: 0.5rem
  }

  .container-sacola {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    padding: 84px 0 96px;
    overflow-y: auto;
    height: 100vh;
    z-index: 1040;
  }

  .container-produtos-sacola {
    padding: 0 15px 15px;
  }

  .ios_platform .add-sacola {
    padding-bottom: 32px;
  }

  .container-sacola.opened {
    display: block;
  }

  .theme-2 .container-sacola {
    display: none;
  }

  @media (max-width: 767px) {
    .container-sacola {
      display: none;
    }
  }

  @media (min-width: 768px) {
    .container-sacola {
      width: 39%;
      top: 80px;
      right: 15px;
      padding: 0 0 22px;
      height: auto;
      box-shadow: var(--shadow);
      z-index: 8;
      border-radius: 12px;
      margin-bottom: 32px;
    }

    .container-produtos-sacola {
      padding: 15px 15px 6px;
      height: calc(100vh - 276px);
      overflow: auto;
      border-bottom: 1px solid #e9e9e9;
      margin-bottom: 16px;
    }

    .btn-enviar {
      background-color: #ffffff;
      position: static;
      border-top: none;
      padding: 0 15px;
    }
  }

  @media (min-width: 1200px) {
    .container-sacola {
      width: 28%;
    }
  }
</style>
